import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const auditDetailsTodo = createAsyncThunk('auditDetails', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `audit/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const auditDetailsSlice = createSlice({
    name: 'auditDetails',
    initialState: {
        data: {},
    },
    extraReducers: (builder) => {
        builder.addCase(auditDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = {}
            }
        });
        builder.addCase(auditDetailsTodo.rejected, () => {
            // console.log('reject', action)
        })
    }
})

export default auditDetailsSlice.reducer;
